'use client';

import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from '@phosphor-icons/react';
import { ClockIcon } from '@/components/icons';
import { isRestaurantOpen } from '@/lib/business-hours';
import { safeGetItem, safeSetItem } from '@/lib/safe-storage';

export function PreorderBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isRestaurantOpen()) {
      const dismissed = safeGetItem('preorder-banner-dismissed', 'session');
      if (!dismissed) setVisible(true);
    }
  }, []);

  const handleClose = () => {
    setVisible(false);
    safeSetItem('preorder-banner-dismissed', '1', 'session');
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ type: 'spring', damping: 24, stiffness: 260 }}
          className="mb-4 mr-4 sm:mr-0 p-4 rounded-2xl bg-[var(--pink-50)] border border-[var(--pink-200)] flex items-start gap-3"
        >
          <div className="w-10 h-10 rounded-xl bg-[var(--pink-500)] flex items-center justify-center flex-shrink-0">
            <ClockIcon weight="fill" className="w-5 h-5 text-white" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-[var(--text-primary)]">
              Работаем с 11:00 до 22:00
            </p>
            <p className="text-xs text-[var(--text-secondary)] mt-0.5">
              Сейчас доступен только предварительный заказ
            </p>
          </div>

          <button
            onClick={handleClose}
            className="p-1.5 rounded-lg text-[var(--text-tertiary)] hover:bg-[var(--pink-100)] transition-colors flex-shrink-0"
            aria-label="Закрыть"
          >
            <X weight="bold" className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
